import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Site from "./site/site";
import Blog from "./site/Blog/blog";
import Artigo from "./site/Blog/artigo";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Site} />
        <Route exact path="/blog" component={Blog} />
        <Route path="/blog/:slug" component={Artigo} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
